<template>
  <div class="tabs-container ng-scope" style="padding-bottom: 50px; margin-top: 18px">
    <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
      <div class="tab-content">
        <div>
          <div class="panel-body">
            <div class="ibox-content">
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Monthly Transfer Limit
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-5">
                  <el-form-item prop="monthlyTransferLimit" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-input onkeyup="value=value.replace(/[^\d]/g,'')" style="margin-bottom: 22px"
                      v-model="detailInfo.monthlyTransferLimit" show-word-limit maxlength="5">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  J Coins Ceiling
                  <span style="color: red">*</span>
                </label>
                <div class="col-sm-5">
                  <el-form-item prop="jcoinsLimit" :rules="{
                    required: true,
                    message: $t('message.required'),
                    trigger: 'change',
                  }">
                    <el-input onkeyup="value=value.replace(/[^\d]/g,'')" style="margin-bottom: 22px"
                      v-model="detailInfo.jcoinsLimit" show-word-limit maxlength="5">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">
                  Redemption Report
                  <span style="color: red; opacity: 0">*</span>
                </label>
                <div class="col-sm-5">
                  <el-date-picker v-model="dateRound" type="daterange" range-separator="to" start-placeholder="Start date"
                    end-placeholder="End date" :picker-options="{
                      disabledDate:(day=>{
                        return this.$dayjs(day).isBefore(this.$dayjs().subtract(184, 'day')) || this.$dayjs(day).isAfter(this.$dayjs())
                      })
                    }">
                  </el-date-picker>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-2 control-label">

                </label>
                <div class="col-sm-10">
                  <el-button type="primary" @click="exportAll()">
                    Export
                  </el-button>
                </div>
              </div>
              <div class="hr-line-dashed"></div>
              <div class="form-group">
                <div class="col-sm-12">
                  <div class="pull-right">
                    <el-button type="primary" @click="checkEvent()">
                      Save
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import eventBus from "../eventbus";
import config from "../config";

export default {
  mixins: [config.globalMixin],
  data() {
    return {
      dateRound:[this.$dayjs().subtract(183, 'day').format('YYYY-MM-DD'),this.$dayjs().format('YYYY-MM-DD')],
      detailInfo: {
        monthlyTransferLimit: "",
        jcoinsLimit: ""
      },
    };
  },
  created() {
    this.init();
  },
  methods: {
    checkEvent() {
      this.$refs["detailInfo"].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    async exportAll() {
      var objdata = this.getAuthObj();
      objdata.apiUrl = this.apiConfig.transferConfigRedemptionReport;
      objdata.begDate = this.$dayjs(this.dateRound[0]).format("YYYY-MM-DD")
      objdata.endDate = this.$dayjs(this.dateRound[1]).format("YYYY-MM-DD")
      let data = await this.$store.dispatch(
        "apiEventFromDataDownload",
        objdata
      );
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      const xlsFileName =
        "RedemptionReport" +
        this.$dayjs(this.dateRound[0]).format("YYYY-MM-DD") + "_to_" + this.$dayjs(this.dateRound[1]).format("YYYY-MM-DD") + 
        ".xls";
      const url = window.URL.createObjectURL(new Blob([data.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", xlsFileName);
      document.body.appendChild(link);
      link.click();
    },
    async init() {
      let obj = this.getAuthObj();
      obj.apiUrl = this.apiConfig.transferConfigLimit;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.result.length) {
        const monthlyTransferLimit = data.data.result.find(i => {
          return i.configKey == "monthly_transfer_limit"
        })
        const jcoinsLimit = data.data.result.find(i => {
          return i.configKey == "j_coins_limit"
        })
        this.detailInfo.monthlyTransferLimit = monthlyTransferLimit ? monthlyTransferLimit.configValue : ''
        this.detailInfo.jcoinsLimit = jcoinsLimit ? jcoinsLimit.configValue : ''
      }
    },
    async submit() {
      let obj = this.getAuthObj();
      obj.lstSystemConfigDTO = []
      obj.lstSystemConfigDTO.push({
        configKey: "monthly_transfer_limit",
        configValue: this.detailInfo.monthlyTransferLimit
      })
      obj.lstSystemConfigDTO.push({
        configKey: "j_coins_limit",
        configValue: this.detailInfo.jcoinsLimit
      })
      obj.apiUrl = this.apiConfig.transferConfigUpdate;
      let data = await this.$store.dispatch("apiEvent", obj);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.$message({
        message: "Save Success",
        type: "success",
      });
      this.init();
    },
  },
  mounted() { },
};
</script>
